var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialYoutube = function SvgSocialYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "social-youtube_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M61.5 7.5v49h-59v-49zm-55 45h51v-41h-51z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M45.984 32 22.485 45.707V18.292zm-19.499 6.743L38.045 32l-11.56-6.744z"
  })));
};
export { SvgSocialYoutube as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNNjEuNSA3LjVWNTYuNUgyLjVWNy41SDYxLjVaTTYuNSA1Mi41SDU3LjVWMTEuNUg2LjVWNTIuNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjxwYXRoIGQ9Ik00NS45ODQ0IDMyLjAwMDFMMjIuNDg1MyA0NS43MDcyVjE4LjI5MjFMNDUuOTg0NCAzMi4wMDAxWk0yNi40ODUzIDM4Ljc0MzNMMzguMDQ0OSAzMi4wMDAxTDI2LjQ4NTMgMjUuMjU2VjM4Ljc0MzNaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";